"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  tableWrap: {
    position: 'relative',
    '&.scrolled': {
      overflow: 'auto',
      minHeight: 200,
      '& $table': {
        position: 'absolute',
        left: 0,
        top: 0,
        minWidth: '100%'
      }
    },
    '&.hidden': {
      display: 'none'
    }
  },
  table: {
    position: 'relative',
    backgroundColor: theme.table.bgColor,
    'z-index': 0,
    '&.disabled': {
      opacity: theme.disabledOpacity,
      '&:hover': {
        cursor: 'default'
      },
      '& .scTableRow, & .scTableRowArrow': {
        '&:hover': {
          cursor: 'default'
        }
      }
    },
    '&.hidden': {
      display: 'none'
    }
  }
});

exports.default = _default;